<!-- 盘点 -->
<template>
  <div class="page-content">
    <c-header pageName="盘点"></c-header>
    <div class="nav-tool">
      <section :class="selectStatus==0?'activity':''" @click="statusChange(0)">库存盘点</section>
      <section :class="selectStatus==1?'activity':''" @click="statusChange(1)">库存盘点复核</section>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :offset="100"
    >
      <div class="check-item flex" v-for="(item,index) in orderList" :key="index">
        <div class="item-content">
          <section>盘点单号 : {{item.checkSn}}</section>
          <section>盘点仓库 : {{item.warehouseName}}</section>
          <section>盘点量 : {{item.checkDetailQty}}</section>
        </div>
        <div class="item-icon" @click="goCheckDetail(item.id)">
          <i class="iconfont xiangyou"></i>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script >
import Header from "../components/headerNav.vue";
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      loading: false,
      finished: true,
      selectStatus: 0, // 0 -- 库存盘点  1-- 库存盘点复核
      orderList: []
    };
  },
  components: {
    "c-header": Header
  },
  mounted() {
    this.getCheckOrderList();
  },
  methods: {
    // 状态切换
    statusChange(value) {
      this.selectStatus = value;
      this.getCheckOrderList();
      this.orderList = [];
    },
    // 获取盘点单
    getCheckOrderList() {
      let checkStatuses = [0, 1];
      if (this.selectStatus == 1) {
        checkStatuses = [2, 3];
      }
      let param = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        checkStatuses: checkStatuses
      };
      this.$post(this.URL.getCheckStockList, param).then(res => {
        if (res.success) {
          this.orderList = [...this.orderList, ...res.data.records];
          if (res.data.totalPage > this.currentPage) {
            this.finished = false;
          } else {
            this.finished = true;
          }
        } else {
          this.$toast.fail(res.message);
        }
        this.loading = false;
      });
    },
    // 加载更多
    onLoad() {
      if (!this.finished) {
        this.currentPage++;
        //this.getCheckOrderList();
      }
    },
    // 盘点详情
    goCheckDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/checkStockDetail",
        query: { checkDetailId: id }
      });
    }
  }
};
</script>

<style lang="scss" scoped >
.nav-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  background-color: #dc6350;
  padding: 0 3rem;
  align-items: center;
  justify-content: center;
  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }
  .activity {
    background-color: white;
    color: #dc6350;
  }

  section:first-child {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
  }
  section:last-child {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
  }
}
.van-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  padding: 0.5rem 0.8rem;
  color: #444;
  .check-item {
    padding: 0.5rem 0;
    border-bottom: 1px dashed #eee;
    .item-content {
      display: inline-flex;
      width: 90%;
      flex-wrap: wrap;
      section {
        display: flex;
        width: 100%;
        line-height: 1.2rem;
      }
    }
    .item-icon {
      display: inline-flex;
      width: 10%;
      align-items: center;
      justify-content: flex-end;
      i {
        font-size: 1.5rem;
        color: #dc6350;
      }
    }
  }
  >>> .van-list__loading {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  >>> .van-list__finished-text {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CheckStock.vue